import "./FolderSelectionOverlay.scss";
import React from 'react';
import {Centre} from '../Centre';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import {FolderActions} from '../../actions/FolderActions';
import {Button} from '@mui/material';
import {useAppDispatch} from "../../hooks/ReduxHooks";

const FolderSelectionOverlay = () => {
    const dispatch = useAppDispatch();

    function onCancelMove() {
        dispatch(FolderActions.cancelMoveFolder());
    }

    return (
        <Centre className="folder-selection-overlay">
            <span>
                <KeyboardBackspaceIcon fontSize="large"/>
                
                <span>Select the destination folder on the left</span>

                <Button onClick={() => onCancelMove()} variant="contained" color="secondary">Cancel</Button>
            </span>
        </Centre>
    );
};

export default FolderSelectionOverlay;
